// Governance/Compliance Questions for IPO Readiness Assessment
// Source: IPO Readiness Score Questions (revised) — uploaded April 2026

const GOVERNANCE_QUESTIONS = [
  {
    id: "gc_1",
    category: "Corporate Structure",
    question: "Is the company already a public limited company or capable of conversion before IPO?",
    positiveAnswer: "yes",
    tooltip: "Public company structure is mandatory before filing DRHP/RHP."
  },
  {
    id: "gc_2",
    category: "Corporate Structure",
    question: "Are there pending mergers, demergers, restructuring or subsidiary rationalisation exercises?",
    positiveAnswer: "no",
    tooltip: "May delay IPO due to need for restated financials, approvals and revised disclosures."
  },
  {
    id: "gc_3",
    category: "Promoter Background",
    question: "Are any promoters/directors disqualified under Companies Act or SEBI regulations?",
    positiveAnswer: "no",
    tooltip: "Major red flag. IPO may be delayed or become ineligible until issue is resolved."
  },
  {
    id: "gc_4",
    category: "Promoter Background",
    question: "Are promoters/directors wilful defaulters, fugitive economic offenders or involved in fraud matters?",
    positiveAnswer: "no",
    tooltip: "Serious disqualification risk under SEBI ICDR Regulations."
  },
  {
    id: "gc_5",
    category: "Share Capital History",
    question: "Are there any pending shareholding disputes or undocumented transfers?",
    positiveAnswer: "no",
    tooltip: "May delay IPO and create legal/title concerns."
  },
  {
    id: "gc_6",
    category: "Share Capital / Dematerialisation",
    question: "Have all existing equity shares of the company been dematerialised and are they available in electronic form with a depository?",
    positiveAnswer: "yes",
    tooltip: "Dematerialisation of all shares is mandatory before IPO. Any pending physical shares, old certificates or unresolved demat issues can delay DRHP filing and listing process."
  },
  {
    id: "gc_7",
    category: "Share Capital / Dematerialisation",
    question: "Has the company entered into tripartite agreements with both depositories and a registrar and transfer agent (RTA)?",
    positiveAnswer: "yes",
    tooltip: "Tripartite agreements with NSDL/CDSL and the RTA are mandatory for demat connectivity before IPO."
  },
  {
    id: "gc_8",
    category: "ROC Compliance",
    question: "Are there any pending ROC penalties, adjudications or compounding matters?",
    positiveAnswer: "no",
    tooltip: "These need to be disclosed and resolved before IPO."
  },
  {
    id: "gc_9",
    category: "Board Composition",
    question: "Does the company have adequate board strength including woman director and independent directors?",
    positiveAnswer: "yes",
    tooltip: "Mandatory for listed company readiness and SEBI LODR compliance."
  },
  {
    id: "gc_10",
    category: "Board Committees",
    question: "Have Audit Committee, NRC, SRC and CSR Committee been properly formed?",
    positiveAnswer: "yes",
    tooltip: "Required before IPO and listing."
  },
  {
    id: "gc_11",
    category: "Secretarial Compliance",
    question: "Are statutory registers, minutes books and approvals maintained properly?",
    positiveAnswer: "yes",
    tooltip: "Smoothens legal due diligence and secretarial audit."
  },
  {
    id: "gc_12",
    category: "Senior Management",
    question: "Does the company have a full-time CFO with adequate listed company / IPO experience?",
    positiveAnswer: "yes",
    tooltip: "A CFO is critical for financial controls, investor confidence, due diligence and IPO execution."
  },
  {
    id: "gc_13",
    category: "Senior Management",
    question: "Does the company have a full-time Company Secretary?",
    positiveAnswer: "yes",
    tooltip: "A full-time CS is generally essential for secretarial compliance, SEBI filings and listing readiness."
  },
  {
    id: "gc_14",
    category: "Governance Policies",
    question: "Does the company have a related party transaction policy?",
    positiveAnswer: "yes",
    tooltip: "Helps manage promoter group dealings and investor concerns."
  },
  {
    id: "gc_15",
    category: "Internal Controls",
    question: "Does the company have ERP/accounting systems capable of monthly MIS and segment reporting?",
    positiveAnswer: "yes",
    tooltip: "Strong systems improve reporting quality and DRHP preparation."
  },
  {
    id: "gc_16",
    category: "Promoter Funding",
    question: "Does the Company have any secured loans to the company?",
    positiveAnswer: "no",
    tooltip: "May require conversion, repayment or proper documentation before IPO."
  },
  {
    id: "gc_17",
    category: "Auditor Matters",
    question: "Have auditors issued qualified reports, adverse remarks or emphasis of matter paragraphs?",
    positiveAnswer: "no",
    tooltip: "These issues may reduce valuation and need detailed explanation."
  },
  {
    id: "gc_18",
    category: "Customer / Vendor Concentration",
    question: "Is the company dependent on one or two major customers or vendors?",
    positiveAnswer: "no",
    tooltip: "High concentration risk may affect valuation."
  },
  {
    id: "gc_19",
    category: "Litigations",
    question: "Does Company have any Pending Litigation involving Promoters & Directors?",
    positiveAnswer: "no",
    tooltip: "Pending litigation involving promoters/directors is a key risk factor for IPO and must be disclosed."
  },
  {
    id: "gc_20",
    category: "Business Related Approvals",
    question: "Does company have relevant Govt approvals for running a business?",
    positiveAnswer: "yes",
    tooltip: "Indicates business discipline and regulatory compliance."
  }
];

// Get unique categories in order of appearance
export const GOVERNANCE_CATEGORIES = [...new Set(GOVERNANCE_QUESTIONS.map(q => q.category))];

export default GOVERNANCE_QUESTIONS;
